import { Events } from '../../utils/servicesEvents'
import { Formatter } from './formatter'
import { TransactionRepo } from './repo'
import { launchTransaction } from './networks/launchTransaction'
import { downloadUserTransactions } from './networks/downloadUserTransactions'
import { getTransaction } from './networks/getTransaction'
import { downloadSubscriptions } from './networks/downloadSubscriptions'

class TransactionController {
  static async downloadData() {
    downloadUserTransactions(
      'transactions_downloaded',
      'failed_to_download_transactions',
    )
    downloadSubscriptions(
      'subscriptions_downloaded',
      'failed_to_download_transactions',
    )
  }

  static async initListeners() {
    Events.handleEvent('transactions_downloaded', async ({ data }) => {
      const db = await TransactionRepo.getDb()
      await db.save(data)
      Events.dispatchEvent('transactions_updated')
    })
    Events.handleEvent('subscriptions_downloaded', async ({ data }) => {
      const db = await TransactionRepo.getDb()
      await db.saveSubscriptions(data)
      Events.dispatchEvent('transactions_updated')
    })

    Events.handleEvent('launch_transaction_request', async data => {
      launchTransaction(
        data,
        'transaction_launched',
        'failed_to_launch_transaction',
      )
    })

    Events.handleEvent('launch_vip_subscription', async data => {
      launchTransaction(
        data,
        'vip_subscription_launched',
        'failed_to_launch_vip_subscription',
      )
    })

    Events.handleEvent(
      'request:transaction',
      async ({ responseId, reference }) => {
        const db = await TransactionRepo.getDb()
        let transaction = await db.findOne(reference)
        if (!transaction) {
          const res = await getTransaction(reference)
          transaction = res.data
        }
        Events.dispatchEvent(responseId, transaction)
      },
    )

    Events.handleEvent('request:transactions', async ({ responseId, type }) => {
      const db = await TransactionRepo.getDb()
      const transactions = await db.get()
      Events.dispatchEvent(responseId, transactions)
      // TransactionController.downloadData()
    })

    Events.handleEvent('request:subscriptions', async ({ responseId, type }) => {
      const db = await TransactionRepo.getDb()
      const transactions = await db.getSubscriptions()
      Events.dispatchEvent(responseId, transactions)
      // TransactionController.downloadData()
    })

    Events.handleEvent('clean_all_data_requested', () => {
      TransactionRepo.getDb().then(async db => {
        await db.clean()
        Events.dispatchEvent('transactions_updated')
      })
    })

    Events.handleEvent('transaction_update_available', async data => {
      const rawTransaction = data?.metaData?.content
      if (!rawTransaction) return
      const transaction = Formatter.parseExternalTransaction(rawTransaction)
      if (!transaction) return
      const db = await TransactionRepo.getDb()

      db.save(transaction).then(() => {
        Events.dispatchEvent('transactions_updated')
        Events.dispatchEvent('single_transaction_updated', transaction)
      })
      TransactionController.downloadData()
    })

    Events.handleEvent('transaction_launched', async data => {
      TransactionController.downloadData()
      setTimeout(TransactionController.downloadData, 3000)
      setTimeout(TransactionController.downloadData, 8000)
    })
    Events.handleEvent('launch_vip_subscription', async data => {
      TransactionController.downloadData()
      setTimeout(TransactionController.downloadData, 3000)
      setTimeout(TransactionController.downloadData, 8000)
    })

    Events.handleEvent(
      'uncompleted_transaction_available_notif',
      async data => {
        const rawTransaction = data?.metaData?.content
        if (!rawTransaction) return
        const transaction = Formatter.parseExternalTransaction(rawTransaction)
        if (!transaction) return
        const db = await TransactionRepo.getDb()

        db.save(transaction).then(() => {
          Events.dispatchEvent('transactions_updated')
          Events.dispatchEvent('uncompleted_transaction_available', transaction)
        })
        TransactionController.downloadData()
      },
    )
  }
}

export { TransactionController }
